<template>
	<div class="print_container full" v-loading="loading">
		<div class="print_header flex">
			<el-button type="primary" v-print="printObj" size="mini">打印/保存PDF</el-button>
			<el-button type="primary" @click="download" size="mini">下载</el-button>
<!-- 			<el-button type="primary" @click="downloadPDF" size="mini">下载PDF</el-button> -->
			<!-- <el-button type="danger" style="position: absolute;right: 10px;" @click="back">返回</el-button> -->
		</div>
		<div class="print full" style="font-size: 14px;">
			<div class="print_paper" v-if="company && customcompany">
				<div class="print_content" id="print_content" ref="printContent"
					style="-webkit-print-color-adjust: exact;box-sizing: border-box;padding: 20px;">
					<div class="logo" v-if="company.logofile.length" >
						<img crossOrigin="anonymous" :src="company.logofile[0].path"  />
					</div>
					<div class="body" style="margin-top: 20px;">
						<table style="width:100%; border-collapse:collapse; margin-bottom:10px;">
							<colgroup>
								<col style="width:70%;">
								<col style="width:30%;">
							</colgroup>
							<tr>
								<td style="padding:2px 0; text-align:center;color: black;" colspan="2">
									<div style="font-size:30px; font-weight:bold;">{{company.name}}</div>
									<div style="font-size:14px;">{{company.address}}</div>
									<div style="font-size:14px;">电话：{{contractphone?contractphone:staff.phone}}
										传真：0577-86376006</div>
									<div style="font-size:30px; font-weight:bold; margin-top:8px;">销 售 合 同</div>
								</td>
							</tr>
							<tr>
								<td>
									<div>供方：{{seller}}</div>
									<div>需方：{{buyer}}</div>
								</td>
								<td>
									<div>合同编号：{{code}}</div>
									<div>合同日期：{{date}}</div>
								</td>
							</tr>
							<tr>
								<td colspan="2" class="notice">
									根据《中华人民共和国民法典》及其他有关法律、法规之规定，在平等、自愿、协商一致的基础上，就需方向供方购买以下货品，双方达成以下协议：</td>
							</tr>
							<tr>
								<td colspan="2" class="detailtitle">一、
									产品名称、规格、数量、金额及交货时间</td>
							</tr>
						</table>
						<table border class="goodsinfo"
							style="width: 100%;text-align: center;border-color: black;color: black;font-size: 12px;">
							<colgroup>
								<col style="width:7%;">
								<col style="width:11.5%;">
								<col style="width:11.5%;">
								<col style="width:11.5%;">
								<col style="width:11.5%;">
								<col style="width:11.5%;">
								<col style="width:11.5%;">
								<col style="width:11.5%;">
							</colgroup>
							<thead>
								<tr>
									<th>序号</th>
									<th>品名</th>
									<th>规格</th>
									<th>数量</th>
									<th>单位</th>
									<th>单价</th>
									<th>金额</th>
									<th>备注</th>
								</tr>
							</thead>
							<tr v-for="(item,index) in tableData" :key="index">
								<td>{{index+1}}</td>
								<td>{{item.goodsname}}</td>
								<td>{{item.goodsmodel}}</td>
								<td>{{item.num}}</td>
								<td>{{getEmunValue('unit',item.goodsunit)}}</td>
								<td>¥{{item.taxfreight}}</td>
								<td>¥{{item.amount}}</td>
								<td>{{item.mark}}</td>
							</tr>
							<tr>
								<td>合计</td>
								<td colspan="2"></td>
								<td>{{totalnum}}</td>
								<td></td>
								<td></td>
								<td>¥{{totalamount}}</td>
								<td></td>
							</tr>
							<tr>
								<td colspan="3">金额合计（人民币大写）</td>
								<td colspan="5">{{totalamountbig}}</td>
							</tr>
						</table>
						<table style="width: 100%;font-size: 14px;margin-top: 10px;">
							<tr>
								<td>
									<div class="detailtitle">二、质量要求、技术标准</div>
									<div class="detail">依照需方与供方确定的样品，或者按照微信协商确认的图片</div>
								</td>
							</tr>
							<tr>
								<td>
									<div class="detailtitle">三、交货信息</div>
									<div class="detail">1、物流方式：物流寄付送货上门，到乙方指定收货地点：{{customcompany.address}}</div>
									<div class="detail">2、产品价格：{{price}}(元) <span
											v-if="additionalcosts>0">{{'（含附加费用：'+additionalcosts+'元）'}}</span></div>
									<div class="detail">3、交期：付款后 标准件产品3天内发货，定做产品7-15天发货</div>
									<div class="detail">4、产品价格含税运，{{invoicepoint}}</div>

								</td>
							</tr>
							<tr>
								<td>
									<div class="detailtitle">四、验货</div>
									<div class="detail">
										需方应在自收货之日起七个工作日验收货物，验货范围包括品名规格、数量、质量、及货物包装是否完好，如有异议，需方可以电话、微信等方式通知供方</div>
								</td>
							</tr>
							<tr>
								<td>
									<div class="detailtitle">五、付款方式</div>
									<div class="detail">样品确认后，供方出货前，需方需要全额付清货款。需方付款需要付到供方指定收款账户（按照合同上提供的收款账户，盖章有效）</div>
								</td>
							</tr>
							<tr>
								<td>
									<div class="detailtitle">六、违约责任</div>
									<div class="detail">按国家有关法律、法规追究违约方责任。</div>
								</td>
							</tr>
							<tr>
								<td>
									<div class="detailtitle">七、解决纠纷方式</div>
									<div class="detail">本合同履行过程中如出现争议，双方友好协商解决。协商不一致，由双方所在地有管辖权的人民法院解决。</div>
								</td>
							</tr>
							<tr>
								<td>
									<div class="detailtitle">八、其它事项</div>
									<div class="detail">本合同一式两份，供需双方各执一份，合同经签字盖章后有效（合同传真件等效）</div>
									<div class="detail">合同如有未尽事宜，须经双方共同协商后作出补充规定，补充规定与本合同具有同等效力。</div>
								</td>
							</tr>
						</table>
						<table border style="width: 100%;font-size: 14px;margin-top: 10px;">
							<tr>
								<td
									style="width: 50%; vertical-align: top; padding: 10px; border: 1px solid black; position: relative;">
									<div><strong>供方：</strong>{{company.name}}</div>
									<div><strong>地 址：</strong>{{company.address}}</div>
									<div><strong>对公账户：</strong>{{company.account}}</div>
									<div><strong>税号：</strong>{{company.taxid}}</div>
									<div><strong>开户行：</strong>{{company.bank}}</div>
									<div><strong>银行账户：</strong>{{company.accountnumber}}</div>
									<div><strong>电话：</strong>{{contractphone ? contractphone : staff.phone}}</div>
									<!-- 印章 -->
									<div v-if="company.sealfile"
										style="position: absolute; bottom: 10px; right: 20px; width: 120px; height: 120px;">
										<img crossOrigin="anonymous" :src="company.sealfile[0].url"
											style="width: 100%; height: 100%;" />
									</div>
								</td>
								<!-- 右列：需方 -->
								<td style="width: 50%; vertical-align: top; padding: 10px; border: 1px solid black;">
									<div><strong>需方：</strong>{{customcompany.name}}</div>
									<div><strong>地址：</strong>{{customcompany.companyaddress}}</div>
									<div><strong>对公账户：</strong>{{customcompany.account}}</div>
									<div><strong>税号：</strong>{{customcompany.taxid}}</div>
									<div><strong>开户行：</strong>{{customcompany.bank}}</div>
									<div><strong>银行账户：</strong>{{customcompany.accountnumber}}</div>
									<div><strong>电话：</strong>{{customcompany.phone}}</div>
								</td>
							</tr>
						</table>
						<!-- 						<div class="detailtitle">二、 质量要求、技术标准</div>
						<div class="detail">依照需方与供方确定的样品，或者按照微信协商确认的图片</div>
						<div class="detailtitle">三、交货信息</div>
						<div class="detail flex">
							<div>
								<span>1、物流方式：物流寄付送货上门，到乙方指定收货地点</span>
								<span style="text-decoration: underline;">{{customcompany.address}}</span>
							</div>
							<div>
								<span>2、产品价格：</span>
								<span>{{price}}(元)</span>
								<span v-if="additionalcosts>0">{{'（含附加费用：'+additionalcosts+'元）'}}</span>
							</div>
							<div>
								<span>3、交期：付款后 标准件产品3天内发货，定做产品7-15天发货</span>
							</div>
							<div>
								<span>4、产品价格含税运，{{invoicepoint}}</span>
							</div>
						</div>
						<div class="detailtitle">四、验货</div>
						<div class="detail">需方应在自收货之日起七个工作日验收货物，验货范围包括品名规格、数量、质量、及货物包装是否完好，如有异议，需方可以电话、微信等方式通知供方</div>
						<div class="detailtitle">五、付款方式</div>
						<div class="detail">样品确认后，供方出货前，需方需要全额付清货款。需方付款需要付到供方指定收款账户（按照合同上提供的收款账户，盖章有效）</div>
						<div class="detailtitle">六、违约责任</div>
						<div class="detail">按国家有关法律、法规追究违约方责任。</div>
						<div class="detailtitle">七、解决纠纷方式</div>
						<div class="detail">本合同履行过程中如出现争议，双方友好协商解决。协商不一致，由双方所在地有管辖权的人民法院解决。</div>
						<div class="detailtitle">八、其它事项</div>
						<div class="detail flex">
							<div>本合同一式两份，供需双方各执一份，合同经签字盖章后有效（合同传真件等效）</div>
							<div>合同如有未尽事宜，须经双方共同协商后作出补充规定，补充规定与本合同具有同等效力。</div>
						</div> -->
						<!-- 						<div class="foot flex">
							<div class="foot_box flex">
								<div>供方：{{company.name}}</div>
								<div>地 址：{{company.address}}</div>
								<div>对公账户：{{company.account}}</div>
								<div>税号：{{company.taxid}}</div>
								<div>开户行：{{company.bank}}</div>
								<div>银行账户：{{company.accountnumber}}</div>
								<div>电话：{{contractphone?contractphone:staff.phone}}</div>
								<div class="seal" v-if="company.sealfile" style="width: 120px;height: 120px"><img
										crossOrigin="anonymous" class="full" :src="company.sealfile[0].url" /></div>
							</div>
							<div class="foot_box flex">
								<div>需方：{{customcompany.name}}</div>
								<div>地址：{{customcompany.companyaddress}}</div>
								<div>对公账户：{{customcompany.account}}</div>
								<div>税号：{{customcompany.taxid}}</div>
								<div>开户行：{{customcompany.bank}}</div>
								<div>银行账户：{{customcompany.accountnumber}}</div>
								<div>电话：{{customcompany.phone}}</div>
							</div>
						</div> -->


					</div>
				</div>
			</div>
		</div>




	</div>
</template>
<style scoped>
	.title {
		position: relative;
		width: 100%;
		color: black;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		margin-top: 30px;

	}

	.header {
		position: relative;
		width: 100%;
		color: black;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 4px 0;
		font-weight: bold;
	}

	.foot {
		position: relative;
		width: 100%;
		color: black;
		flex-direction: row;
		justify-content: space-around;
		box-sizing: border-box;
		padding: 4px 10px;

	}

	.foot_box {
		position: relative;
		border: 1px solid black;
		width: 49%;
		margin-bottom: 50px;
		flex-direction: column;
		box-sizing: border-box;
		padding: 10px;

	}

	.foot_box>div {
		margin: 2px 0px;
	}

	.notice {
		position: relative;
		width: 100%;
		color: black;
		box-sizing: border-box;
		font-weight: bold;
	}

	.detailtitle {
		position: relative;
		width: 100%;
		color: black;
		box-sizing: border-box;
		font-weight: bold;
		padding: 4px 0px;
	}

	.detail {
		position: relative;
		width: 100%;
		color: black;
		box-sizing: border-box;
		padding: 0px 32px;
		font-weight: bold;
		font-weight: normal;
		box-sizing: border-box;
		flex-direction: column;
	}


	.header_notice {

		margin-right: 40px;
	}

	.header_title {
		font-size: 30px;
		font-weight: bold;
		flex: 1;
		text-align: center;
	}

	.body_part2 {

		box-sizing: border-box;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.body_part3 {
		font-size: 14px;
		box-sizing: border-box;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.body_part4 {
		font-size: 14px;
		box-sizing: border-box;
		padding: 10px;
	}

	.logo {
		position: absolute;
		width: 80px;
		z-index: 10;

	}

	.seal {
		position: absolute;
		width: 100px;
		height: 100px;
		right: 10px;
		bottom: 10px;
		z-index: 10;

	}
</style>
<style>
	.print-col-black {
		background-color: black;
		color: #fff;
	}

	@page {
		margin-top: 10mm;
		margin-bottom: 10mm;
		margin-left: 10mm;
		margin-right: 10mm;
	}

	@media print {
		tr {
			page-break-inside: avoid;
		}

		thead {
			display: table-header-group;
		}

		tfoot {
			display: table-footer-group;
		}
	}
</style>
<script>
	// import {
	// 	jsPDF
	// } from "jspdf";
	import html2canvas from 'html2canvas';
	export default {
		props: {
			id: {
				default: () => {
					return 0
				}
			},
			mainForm: {
				default: () => {
					return null
				}
			},
			name: {
				type: String,
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				loading: false,
				mainData: null,
				seller: null,
				buyer: null,
				code: null,
				date: null,
				totalnum: 0,
				totalamount: 0,
				totalamountbig: null,
				printObj: {
					id: "print_content", // 这里是要打印元素的ID
					popTitle: "&nbsp", // 打印的标题
					extraCss: '', // 打印可引入外部的一个 css 文件
					extraHead: "", // 打印头部文字
					preview: false,
					previewTitle: '报价单预览',
					price: 0,
					beforeOpenCallback: () => {
						let timeStamp = new Date().getTime()
						let date = window.systemMethods.timestampToDate(timeStamp, true)
						let title = "报价合同_" + this.mainData.customername + "_" + date
						document.title = title
					},
				},
				company: null,
				customcompany: null,
				staff: {},
				contractphone: null,
				tableData: [],
				invoicepoint: '开13%增值税专用发票',
				headData: [{
						id: 1,
						a: '业务员',
						b: '',
						c: '联系方式',
						d: '',
						e: '公司地址',
						f: '',
						g: '',
						h: ''
					},
					{
						id: 2,
						a: '客户',
						b: '',
						c: '联系方式',
						d: '',
						e: '公司地址',
						f: '',
						g: '',
						h: ''
					},
				],
				infoData: [{
						id: 1,
						a: '供方',
						b: '',
						c: '',
						d: '',
						e: '',
						f: '合同编号',
						g: '',
						h: ''
					},
					{
						id: 2,
						a: '需方',
						b: '',
						c: '',
						d: '',
						e: '',
						f: '合同日期',
						g: ''
					}
				],
				resData: [{
					id: 1,
					a: '总数量',
					b: '',
					c: '总计金额',
					d: '',
					e: '',
					f: ''
				}, {
					id: 2,
					a: '金额合计（人民币大写）',
					b: '',
					c: '',
					d: '',
					e: '',
					f: '',
					g: ''
				}],
				headmergeCells: [{
						row: 0,
						col: 5,
						rowspan: 1,
						colspan: 3
					},
					{
						row: 1,
						col: 5,
						rowspan: 1,
						colspan: 3
					}
				],
				mergeCells: [{
						row: 0,
						col: 1,
						rowspan: 1,
						colspan: 4
					},
					{
						row: 0,
						col: 6,
						rowspan: 1,
						colspan: 2
					},
					{
						row: 1,
						col: 1,
						rowspan: 1,
						colspan: 4
					},
					{
						row: 1,
						col: 6,
						rowspan: 1,
						colspan: 2
					},
				],
				resmergeCells: [{
						row: 0,
						col: 3,
						rowspan: 1,
						colspan: 3
					},
					{
						row: 1,
						col: 0,
						rowspan: 1,
						colspan: 3
					},
					{
						row: 1,
						col: 3,
						rowspan: 1,
						colspan: 3
					}
				]
			}
		},
		created() {
			this.init()
		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},

		methods: {
			getEmunValue(field, value) {
				return window.systemMethods.getEmunValue(field, value)
			},
			init() {
				this.mainData = this.mainForm.fApi.formData()
				//console.log(this.mainData)
				if (this.mainData.Includingtax == 3) {
					this.price = parseFloat(this.mainData.pretaxprice)
				} else {
					this.price = parseFloat(this.mainData.price)
				}

				if (this.mainData.invoicetype == 331) {
					this.invoicepoint = '开13%增值税专用发票'
				}
				if (this.mainData.invoicetype == 7968) {
					this.invoicepoint = '开1%普票'
				}



				this.additionalcosts = this.mainData.additionalcosts ? this.mainData.additionalcosts : 0


				let customcompany = {
					name: this.mainData.customername,
					account: this.mainData.customercompany,
					accountnumber: this.mainData.customeraccountnumber,
					taxid: this.mainData.customertaxid,
					address: this.mainData.customeraddress,
					companyaddress: this.mainData.customercompanyaddress,
					bank: this.mainData.customerbank,
					phone: this.mainData.customerphone,
				}
				this.customcompany = customcompany


				// this.$api.customer.getById(this.mainData.customerid).then((res)=>{
				// 	let customcompany = {
				// 		name: res ? res.nickname:null,
				// 		account: res ? res.account:null,
				// 		accountnumber: res ? res.accountnumber:null,
				// 		taxid: res ? res.taxid:null,
				// 		address: res ? res.address:null,
				// 		bank: res ? res.bank:null,
				// 		phone: res ? res.phone:null,
				// 	}
				// 	this.customcompany = customcompany
				// })	


				this.tableData = this.mainForm.fApi.el('$son_offer_goods').store.table.getTableData().fullData

				let request = [this.getdetail(), this.getconfig(), this.getcompany()]
				Promise.all(request).then((res) => {
					console.log(res)
					if (res[0]) {
						this.staff = res
						this.headData[0].b = res[0].name
						this.headData[0].d = res[0].phone
					}
					if (res[1]) {
						let configdata = res[1].config ? res[1].config : {}
						this.contractphone = configdata.contractphone
						if (this.contractphone) {
							this.headData[0].d = this.contractphone
						}
					}
				})


				// this.$api.staff.getdetail(this.mainData.staffid).then((res) => {
				// 	this.staff = res
				// 	this.headData[0].b = res.name
				// 	this.headData[0].d = res.phone
				// 	this.companyid = this.mainData.companyid
				// 	if(this.companyid){
				// 		this.$api.company.getById(this.companyid).then((res) => {
				// 			this.company = res
				// 			if(this.company){
				// 				this.company.accountnumber = this.mainData.companyaccount
				// 			}							
				// 			this.headData[0].f = res ? res.address : null
				// 			this.headData[1].b = this.mainData.customername
				// 			this.headData[1].d = this.mainData.customerphone
				// 			this.headData[1].f = this.mainData.customeraddress

				// 			this.seller = res ? res.name : null
				// 			this.code = this.mainData.code
				// 			this.buyer = this.mainData.customercompany
				// 			this.date = window.systemMethods.timestampToDate(this.mainData
				// 				.commit_time, true)
				// 			this.totalnum = this.mainData.num
				// 			this.totalamount = this.price
				// 			this.totalamountbig = window.systemMethods.digitUppercase(this.price)
				// 			// this.resData[0].b = this.mainData.num
				// 			// this.resData[0].d = this.price
				// 			// this.resData[1].d = window.systemMethods.digitUppercase(this.price)
				// 		})
				// 	}else{
				// 		this.$message.error('开票公司不存在')
				// 	}
				// })
			},
			getdetail() {
				return new Promise((reslove) => {
					this.$api.staff.getdetail(this.mainData.staffid).then((res) => {
						reslove(res)
					}, () => {
						reslove(null)
					})
				})
			},
			getconfig() {
				return new Promise((reslove) => {
					this.$api.config.get(0, {
						module: 'offer'
					}).then((res) => {
						reslove(res)
					}, () => {
						reslove(null)
					})
				})
			},
			getcompany() {
				return new Promise((reslove) => {
					this.companyid = this.mainData.companyid
					let companyaccount = this.mainData.companyaccount
					if (this.companyid) {
						this.$api.company.getById(this.companyid,{companyaccount:companyaccount}).then((res) => {
							this.company = res
							if (this.company) {
								this.company.accountnumber = this.mainData.companyaccount
							}
							this.headData[0].f = res ? res.address : null
							this.headData[1].b = this.mainData.customername
							this.headData[1].d = this.mainData.customerphone
							this.headData[1].f = this.mainData.customeraddress

							this.seller = res ? res.name : null
							this.code = this.mainData.code
							this.buyer = this.mainData.customercompany
							this.date = window.systemMethods.timestampToDate(this.mainData
								.commit_time, true)
							this.totalnum = this.mainData.num
							this.totalamount = this.price
							this.totalamountbig = window.systemMethods.digitUppercase(this.price)
							reslove()
							// this.resData[0].b = this.mainData.num
							// this.resData[0].d = this.price
							// this.resData[1].d = window.systemMethods.digitUppercase(this.price)
						})

					} else {
						this.$message.error('开票公司不存在')
						reslove()
					}

				})
			},

			headerCellClassName() {
				return 'print-col-black'
			},
			download() {
				this.loading = true
				html2canvas(this.$refs.printContent, {
					scale: 4,
					useCORS: true
				}).then((canvas) => {
					this.convertCanvasToImg(canvas)
					this.loading = false
				})
			},



			downloadPDF() {
				this.$alert('点击打印——更多设置——使用系统对话框进行打印——导出为WPS PDF——打印', '方法', {
					confirmButtonText: '确定'
				})

				// this.loading = true
				// let scale = 2
				// html2canvas(this.$refs.printContent, {
				// 	scale: scale,
				// 	useCORS: true
				// }).then((canvas) => {
				// 	let timeStamp = new Date().getTime()
				// 	let date = window.systemMethods.timestampToDate(timeStamp, true)
				// 	let title = "销售单_" + this.mainData.customername + "_" + date
				// 	let contentWidth = canvas.width / scale
				// 	let contentHeight = canvas.height / scale
				// 	let PDF = new jsPDF('p', 'pt', [contentWidth, contentHeight])
				// 	let pdfWidth = PDF.internal.pageSize.getWidth()
				// 	let pdfHeight = contentHeight / contentWidth * pdfWidth
				// 	let pageData = canvas.toDataURL('image/jpeg', 1.0)
				// 	PDF.addImage(pageData, 'JPEG', 0, 0, pdfWidth, pdfHeight)
				// 	PDF.save(title + '.pdf')
				// 	this.loading = false
				// })
			},
			convertCanvasToImg(canvas) {
				let myBlob = this.dataURLtoBlob(canvas.toDataURL('img/png', 0.92))
				let myUrl = URL.createObjectURL(myBlob)
				this.downImg(myUrl)
			},
			dataURLtoBlob(dataurl) {
				let arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime
				});
			},
			downImg(url) {
				let timeStamp = new Date().getTime()
				let date = window.systemMethods.timestampToDate(timeStamp, true)
				let a = document.createElement("a")
				let clickEvent = document.createEvent("MouseEvents")
				a.setAttribute("href", url)
				a.setAttribute("download", "销售单_" + this.mainData.customername + "_" + date)
				a.setAttribute("target", '_blank')
				clickEvent.initEvent('click', true, true)
				a.dispatchEvent(clickEvent)
			},
			back() {
				this.$emit('back')
			}
		},
		components: {

		}
	}
</script>